import { EditorState, NodeApi } from '@candulabs/craft';

import { Resolver } from 'craft/types';

import { internalNodesResolvers, leafResolver } from './constants';
import { deleteNodes } from './deleteNodes';

// Remove any invalid Slate nodes (ie: Slate nodes without any Text nodes)
export const removeOrphanNodes = (editorState: EditorState) => {
  const rteNodeIds: string[] = Object.values(editorState.nodes)
    .filter((node) => internalNodesResolvers.includes(node.data.type as Resolver))
    .map((node) => node.id);

  // TODO: make this functional...
  let anchestorNodeIds = new Set();
  Object.values(editorState.nodes)
    // find all GOOD leaf nodes
    .filter((node) => node.data.type === leafResolver)
    // then record all the ancestors of those nodes
    .forEach((node) => {
      const ancestors = new NodeApi(editorState.nodes, node.id).ancestors(true);
      anchestorNodeIds = new Set([...Array.from(anchestorNodeIds), ...ancestors]);
    });

  // find any node that doenst have an rte ancestor and delete it
  const nodeIdsToDelete = rteNodeIds.filter((nodeId: string) => !anchestorNodeIds.has(nodeId));

  deleteNodes(
    editorState,
    nodeIdsToDelete.map((n) => [n]),
  );

  return editorState;
};
